export enum CommentEndpoints {
	Create = '/comments',
	Update = '/comments/:ownerId',
	Get = '/comments/by/:ownerId',
	GetAll = '/comments/:ownerId',
	GetAllForForum = '/comments/forum/:ownerId',
	Delete = '/comments/:ownerId/:id',
}
